import React, { useState, useEffect } from 'react'
import useSiteContext from '@/context/SiteContext'

const INITIAL_MESSAGE = `Deseo recibir información sobre productos, servicios y material de
publicidad de parte de Copesa y otros socios comerciales (opcional)`

export const Optin = ({ message = INITIAL_MESSAGE, defaultState = false }) => {
  const { email, optin, updateOptin } = useSiteContext()

  const handleOptinChange = () => {
    updateOptin(!optin)
    console.log('change inside')
  }

  return (
    <div>
      <form>
        <input
          id="optin"
          type="checkbox"
          name="optin"
          value={optin}
          defaultChecked={defaultState}
          onChange={handleOptinChange}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded cursor-pointer focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        />
        <label
          htmlFor="optin"
          className="ml-2 text-sm tracking-tight cursor-pointer">
          {message}
        </label>
      </form>
    </div>
  )
}
